import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

import { baseApiURL } from '../configs';

Vue.use(Vuex);
const authUrl = baseApiURL + '/api/user';

const state = {
  status: '',
  token: localStorage.getItem('token') || '',
  user: JSON.parse(localStorage.getItem('user')) || {},
  assetId: '',
};

const mutations = {
  auth_request(state) {
    state.status = 'loading';
  },
  auth_success(state, resp) {
    state.status = 'success';
    state.token = `${resp.data.token}`;
    state.user = resp.data.user;
    state.avatar = resp.data.avatar;
  },
  auth_error(state) {
    state.status = 'error';
  },
  logout(state) {
    state.status = '';
    state.token = '';
    state.avatar = '';
  },
  sign_in(state) {
    state.login = true;
  },
  sign_out(state) {
    state.login = false;
  },
  set(state, [variable, value]) {
    state[variable] = value;
  },
};
const actions = {
  login({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request');
      axios({ url: `${authUrl}/signIn`, data: user, method: 'POST' })
        .then(resp => {
          console.log(authUrl);
          const { token } = resp.data;
          localStorage.setItem('token', `${token}`);
          localStorage.setItem('user', JSON.stringify(resp.data.user));
          axios.defaults.headers.common.Authorization = localStorage.getItem(
            'token'
          );
          commit('auth_success', resp);
          resolve(resp);
        })
        .catch(err => {
          commit('auth_error');
          localStorage.removeItem('token');
          reject(err);
        });
    });
  },
  register({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request');
      axios({ url: `${authUrl}/signUp`, data: user, method: 'POST' })
        .then(resp => {
          localStorage.setItem('user', JSON.stringify(resp.data.user));
          commit('auth_success', resp);
          resolve(resp);
        })
        .catch(err => {
          commit('auth_error', err);
          localStorage.removeItem('token');
          reject(err);
        });
    });
  },
  logout({ commit }) {
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, reject) => {
      commit('logout');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('asset');
      delete axios.defaults.headers.common.Authorization;
      resolve();
    });
  },
  saveAssetId({ commit }, assetId) {
    commit('set', ['assetId', assetId]);
  },
  clearAssetId({ commit }) {
    commit('set', ['assetId', '']);
  },
};
const getters = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  getUser: state => state.user,
  getAvatar: state => state.avatar,
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
});
